module.exports = __webpack_public_path__ + "img/add.4a0ff107.svg";